const eeDashboard = "EmployementEquityDashboard";
export const GetChartHeadCount = `/${eeDashboard}/GetChartHeadCount`;
export const GetMovementChartData = `/${eeDashboard}/GetMovementChart`;
export const GetChartIncomeDifferentials = `/${eeDashboard}/GetChartIncomeDifferentials`;
export const GetIncomeDifferentialPopup = `/${eeDashboard}/GetIncomeDifferentialPopup`;
export const GetChartIncomeDifferentialsAnalysis = `/${eeDashboard}/GetChartIncomeAnalysis`;
export const GetDashboardConfig = `/${eeDashboard}/Get/`;
export const SaveDashboardConfig = `/${eeDashboard}/SaveConfiguration`;
export const GetSourceScorecardLookups = `/${eeDashboard}/GetSourceScorecardLookups`;
export const GetEEPlanAnnualTrackingHeadcount = `/${eeDashboard}/GetEEPlanAnnualTrackingHeadcount`;
export const GetEEPlan5YearTrackingHeadcount = `/${eeDashboard}/GetEEPlan5YearTrackingHeadcount`;
